import { render, staticRenderFns } from "./ResetLinkValidation.vue?vue&type=template&id=6e30cf6b"
import script from "./ResetLinkValidation.vue?vue&type=script&lang=js"
export * from "./ResetLinkValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports